import React from "react";
import { useRfi } from "../../../contexts/RfiContext";

const AssemblyReport = () => {
  const { stagesData } = useRfi();
  const { assembly } = stagesData;

  return (
    <div style={{ width: "100%", fontSize: "10px", color: "#222222" }}>
      <div style={{ paddingBottom: "2px" }} data-pdf-section="assembly-title">
        <div
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            marginBottom: "10px",
            padding: "6px 10px",
            backgroundColor: "#073642",
            color: "#fff",
            letterSpacing: "0.5px",
          }}
        >
          Visual Check Details
        </div>
      </div>
      <div>
        {assembly?.data?.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#f5f5f5",
              padding: "10px",
              // margin: "5px 0px",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "3px",
            }}
            data-pdf-section={`assembly-item-${index}`}
          >
            <div style={{ display: "flex", gap: "10px", width: "50%" }}>
              <div style={{ fontWeight: "bold" }}>{index + 1}</div>
              <div style={{ fontWeight: "bold" }}>Part Name:</div>
              <div>{item.part_name}</div>
            </div>
            <div style={{ display: "flex", gap: "10px", width: "50%" }}>
              <div style={{ fontWeight: "bold" }}>Sticker Pasted:</div>
              <div
                style={{
                  fontWeight: "bold",
                  color: item.sticker_pasted ? "green" : "red",
                }}
              >
                {item.sticker_pasted ? "✓" : "✗"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssemblyReport;
